module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-coins-lg-e34faa06064e61ca4b22f0cd9a18fa3a.svg";